import React from "react";
import { CButton, CCard, CCardBody, CCardImage, CCardText, CCardTitle } from '@coreui/react'
import dayjs from "dayjs";
import { ButtonBack, ButtonNext, CarouselProvider, Slide, Slider } from 'pure-react-carousel';

import previousButton from "../../../images/previous.svg"
import forwardButton from "../../../images/right-arrow.svg"

import 'pure-react-carousel/dist/react-carousel.es.css';

function MessageA56(props) {

  const messageTimeStyle = () => {
    return props.config?.customDesign?.messageA56Time;
  }

  console.log('carousel', props.entry)

  let carouselCard = (props.entry && props.entry.text_data && props.entry.text_data.carouselCard) || {};
  console.log(props, "MessageA56PROPS")
  return (
    <div className="s360-message-cotainer-received-56" style={{ width: '100%' }}>
      <CarouselProvider naturalSlideWidth={100} naturalSlideHeight={100} totalSlides={carouselCard.cardContents.length}>
        <ButtonBack className="A56-button-1">
          <img src={previousButton} alt="" style={{
            width: "40px",
            height: "40px",
            background: "none !important",
            border: "none !important"
          }} />
        </ButtonBack>
        <div style={{
          display: "flex",
          width: "82%",
          background: "#525252",
          marginLeft: "auto",
          marginRight: "auto",
          borderRadius: "12px"
        }}>
          <Slider>
            {carouselCard.cardContents.map((item, i) =>
              <div key={i}>
                <Slide index={i}>
                  <CCard style={{ width: '100%', height: '100%' }}>
                    <CCardImage orientation="top"
                      src={item?.media?.contentInfo?.fileUrl}
                      style={{
                        width: "100%",
                        marginLeft: "auto",
                        marginRight: "auto",
                        display: "block"
                      }} />
                    <CCardBody>
                      <CCardTitle>{item.title}</CCardTitle>
                      <CCardText>
                        {item.description}
                      </CCardText>
                      <CButton className="A56-button" onClick={() => {
                        window.open(item.suggestions[1]?.action?.openUrlAction?.url)
                      }}>{item.suggestions[0]?.reply?.text}</CButton>
                    </CCardBody>
                  </CCard>
                </Slide>
              </div>
            )}
          </Slider>
        </div>
        <ButtonNext className="A56-button-2"><img alt="" src={forwardButton} style={{
          width: "40px",
          height: "40px",
          background: "none",
          border: "none"
        }} /></ButtonNext>

      </CarouselProvider>

      <br />

      {props.isLastEntry && props.sentTimestamp && <div className="s360-message-time-received" style={messageTimeStyle()}>
        {dayjs.unix(Math.trunc(props.sentTimestamp / 1000)).format("DD MMM h:mm a")}
      </div>}
    </div>
  );
}

export default MessageA56;
